<mat-card appearance="outlined" class="mb-3" *ngIf="showExistingPolicy">
    <mat-card-title>Existing Endorsements</mat-card-title>
    <mat-card-content>
        <ag-grid-angular
            domLayout="autoHeight"
            class="ag-theme-material"
            [gridOptions]="existingEndorsementsGridOptions"
            [rowData]="existingEndorsements"
            (cellValueChanged)="rowDataChanged($event, endorsementsGridOptions)"
            (gridSizeChanged)="resize($event, endorsementsGridOptions)"
            [getRowStyle]="getRowStyle"
            style="width: 100%"
        ></ag-grid-angular>
    </mat-card-content>
</mat-card>
<mat-card appearance="outlined" class="mb-3">
    <mat-card-title>Proposed Endorsements</mat-card-title>
    <mat-card-content>
        <ag-grid-angular
            domLayout="autoHeight"
            class="ag-theme-material"
            [gridOptions]="endorsementsGridOptions"
            [rowData]="asset.endorsements"
            (cellValueChanged)="rowDataChanged($event, endorsementsGridOptions)"
            (gridSizeChanged)="resize($event, endorsementsGridOptions)"
            [getRowStyle]="getRowStyle"
        ></ag-grid-angular>
    </mat-card-content>
</mat-card>
